<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon">close</mat-icon>
</button>
<h1 mat-dialog-title *ngIf="edit" align="center">Editar usuario</h1>
<h1 mat-dialog-title *ngIf="!edit" align="center">Crear nuevo usuario</h1>
<div mat-dialog-content>
    <table class="full-width" cellspacing="2">
      <tr>
        <td><mat-form-field>
    <mat-label>Primer Nombre</mat-label>
    <input matInput type="text" [(ngModel)]="nombre1" [disabled]="!disabled[0]">
</mat-form-field></td>
<td *ngIf="edit" class="checkbox">
      <mat-checkbox [(ngModel)]="disabled[0]"></mat-checkbox>
    </td>
        <td><mat-form-field>
    <mat-label>Segundo Nombre</mat-label>
    <input matInput type="text" [(ngModel)]="nombre2" [disabled]="!disabled[1]">
</mat-form-field></td>
<td *ngIf="edit" class="checkbox">
  <mat-checkbox [(ngModel)]="disabled[1]"></mat-checkbox>
</td>
      </tr>
      <tr>
        <td><mat-form-field>
    <mat-label>Primer Apellido</mat-label>
    <input matInput type="text" [(ngModel)]="apellido1" [disabled]="!disabled[2]">
</mat-form-field></td>
<td *ngIf="edit" class="checkbox">
      <mat-checkbox [(ngModel)]="disabled[2]"></mat-checkbox>
    </td>
        <td><mat-form-field>
    <mat-label>Segundo Apellido</mat-label>
    <input matInput type="text" [(ngModel)]="apellido2" [disabled]="!disabled[3]">
</mat-form-field></td>
<td *ngIf="edit" class="checkbox">
      <mat-checkbox [(ngModel)]="disabled[3]"></mat-checkbox>
    </td>
      </tr>
      <tr>
        <td><mat-form-field>
        <mat-label>Tipo de Documento</mat-label>
        <mat-select  [(ngModel)]="tipoDoc" [disabled]="!disabled[4]">
          <mat-option value="CC">Cedula de Ciudadania</mat-option>
          <mat-option value="CE">Cedula de Extranjeria</mat-option>
          <mat-option value="TI">Tarjeta de Identidad</mat-option>
          <mat-option value="PS">Pasaporte</mat-option>
          <mat-option value="NIT">NIT</mat-option>
        </mat-select>
    </mat-form-field></td>
    <td *ngIf="edit" class="checkbox">
          <mat-checkbox [(ngModel)]="disabled[4]"></mat-checkbox>
        </td>
        <td><mat-form-field>
    <mat-label>Numero de Documento</mat-label>
    <input matInput type="number" [(ngModel)]="numDoc" [disabled]="!disabled[5]">
  </mat-form-field></td>
  <td *ngIf="edit" class="checkbox">
        <mat-checkbox [(ngModel)]="disabled[5]"></mat-checkbox>
      </td>
      </tr>
      <tr>
        <td><mat-form-field>
    <mat-label>Correo Electronico</mat-label>
    <input matInput type="email" [(ngModel)]="email" [disabled]="!disabled[6]">
</mat-form-field></td>
<td *ngIf="edit" class="checkbox">
      <mat-checkbox [(ngModel)]="disabled[6]"></mat-checkbox>
    </td>
      </tr>
      <tr>
        <td><mat-form-field>
    <mat-label>Usuario</mat-label>
    <input matInput type="text" [(ngModel)]="user" [disabled]="!disabled[7]">
</mat-form-field></td>
<td *ngIf="edit" class="checkbox">
      <mat-checkbox [(ngModel)]="disabled[7]"></mat-checkbox>
    </td>
        <td><mat-form-field>
    <mat-label >Contraseña</mat-label>
    <input matInput type="text" [(ngModel)]="pass" [disabled]="!disabled[8]" [type]="!disabled[8] ? 'password' : 'text'">
</mat-form-field></td>
<td *ngIf="edit" class="checkbox">
      <mat-checkbox [(ngModel)]="disabled[8]"></mat-checkbox>
    </td>
      </tr>
      <tr>
        <td *ngIf="!edit"><mat-form-field>
        <mat-label>Rol</mat-label>
        <mat-select [(ngModel)]="rol" [disabled]="!disabled[9]">
          <mat-option value="1">Administrador</mat-option>
          <mat-option value="2">Reconocedor</mat-option>
          <mat-option value="3">Consulta</mat-option>
        </mat-select>
    </mat-form-field></td>
    <!-- <td *ngIf="edit" class="checkbox">
          <mat-checkbox [(ngModel)]="disabled[9]"></mat-checkbox>
        </td> -->
      </tr>
    </table>
</div>
<div mat-dialog-actions>
  <button mat-raised-button *ngIf="!edit"  (click)="createUser()">Crear Usuario</button>
  <button mat-raised-button *ngIf="edit" (click)="editUser()">Editar Usuario</button>
  <button mat-raised-button [mat-dialog-close] cdkFocusInitial>Cancelar</button>
</div>
